export const REGION_OPTIONS = [
  { id: 'hk-island', nameEn: 'Hong Kong Island', nameZh: '港島', bbox: [114.103, 22.207, 114.292, 22.303] },
  { id: 'kowloon', nameEn: 'Kowloon', nameZh: '九龍', bbox: [114.133, 22.275, 114.247, 22.368] },
  { id: 'new-territories', nameEn: 'New Territories', nameZh: '新界', bbox: [113.835, 22.278, 114.449, 22.566] },
]

export const DISTRICT_OPTIONS = [
  {
    id: 'central-western',
    nameEn: 'Central and Western',
    nameZh: '中西區',
    regionId: 'hk-island',
    bbox: [114.12, 22.26, 114.17, 22.295],
    subDistricts: [
      'Kennedy Town (堅尼地城)',
      'Shek Tong Tsui (石塘咀)',
      'Sai Ying Pun (西營盤)',
      'Sheung Wan (上環)',
      'Central (中環)',
      'Admiralty (金鐘)',
      'Mid-levels (半山區)',
      'Peak (山頂)',
    ],
  },
  {
    id: 'wan-chai',
    nameEn: 'Wan Chai',
    nameZh: '灣仔',
    regionId: 'hk-island',
    bbox: [114.163, 22.261, 114.201, 22.287],
    subDistricts: [
      'Wan Chai (灣仔)',
      'Causeway Bay (銅鑼灣)',
      'Happy Valley (跑馬地)',
      'Tai Hang (大坑)',
      'So Kon Po (掃桿埔)',
      "Jardine's Lookout (渣甸山)",
    ],
  },
  {
    id: 'eastern',
    nameEn: 'Eastern',
    nameZh: '東區',
    regionId: 'hk-island',
    bbox: [114.18, 22.255, 114.294, 22.303],
    subDistricts: [
      'Tin Hau (天后)',
      'Braemar Hill (寶馬山)',
      'North Point (北角)',
      'Quarry Bay (鰂魚涌)',
      'Sai Wan Ho (西灣河)',
      'Shau Kei Wan (筲箕灣)',
      'Chai Wan (柴灣)',
      'Siu Sai Wan (小西灣)',
    ],
  },
  {
    id: 'southern',
    nameEn: 'Southern',
    nameZh: '南區',
    regionId: 'hk-island',
    bbox: [114.12, 22.203, 114.255, 22.275],
    subDistricts: [
      'Pok Fu Lam (薄扶林)',
      'Aberdeen (香港仔)',
      'Ap Lei Chau (鴨脷洲)',
      'Wong Chuk Hang (黃竹坑)',
      'Shouson Hill (壽臣山)',
      'Repulse Bay (淺水灣)',
      'Chung Hom Kok (舂磡角)',
      'Stanley (赤柱)',
      'Tai Tam (大潭)',
      'Shek O (石澳)',
    ],
  },
  {
    id: 'yau-tsim-mong',
    nameEn: 'Yau Tsim Mong',
    nameZh: '油尖旺',
    regionId: 'kowloon',
    bbox: [114.152, 22.294, 114.177, 22.327],
    subDistricts: [
      'Tsim Sha Tsui (尖沙咀)',
      'Yau Ma Tei (油麻地)',
      'West Kowloon Reclamation (西九龍填海區)',
      "King's Park (京士柏)",
      'Mong Kok (旺角)',
      'Tai Kok Tsui (大角咀)',
    ],
  },
  {
    id: 'sham-shui-po',
    nameEn: 'Sham Shui Po',
    nameZh: '深水埗',
    regionId: 'kowloon',
    bbox: [114.138, 22.318, 114.179, 22.353],
    subDistricts: [
      'Mei Foo (美孚)',
      'Lai Chi Kok (荔枝角)',
      'Cheung Sha Wan (長沙灣)',
      'Sham Shui Po (深水埗)',
      'Shek Kip Mei (石硤尾)',
      'Yau Yat Tsuen (又一村)',
      'Tai Wo Ping (大窩坪)',
      'Stonecutters Island (昂船洲)',
    ],
  },
  {
    id: 'kowloon-city',
    nameEn: 'Kowloon City',
    nameZh: '九龍城',
    regionId: 'kowloon',
    bbox: [114.17, 22.304, 114.214, 22.344],
    subDistricts: [
      'Hung Hom (紅磡)',
      'To Kwa Wan (土瓜灣)',
      'Ma Tau Kok (馬頭角)',
      'Ma Tau Wai (馬頭圍)',
      'Kai Tak (啟德)',
      'Kowloon City (九龍城)',
      'Ho Man Tin (何文田)',
      'Kowloon Tong (九龍塘)',
      'Beacon Hill (筆架山)',
    ],
  },
  {
    id: 'wong-tai-sin',
    nameEn: 'Wong Tai Sin',
    nameZh: '黃大仙',
    regionId: 'kowloon',
    bbox: [114.179, 22.329, 114.224, 22.367],
    subDistricts: [
      'San Po Kong (新蒲崗)',
      'Wong Tai Sin (黃大仙)',
      'Tung Tau (東頭)',
      'Wang Tau Hom (橫頭磡)',
      'Lok Fu (樂富)',
      'Diamond Hill (鑽石山)',
      'Tsz Wan Shan (慈雲山)',
      'Ngau Chi Wan (牛池灣)',
    ],
  },
  {
    id: 'kwun-tong',
    nameEn: 'Kwun Tong',
    nameZh: '觀塘',
    regionId: 'kowloon',
    bbox: [114.204, 22.294, 114.249, 22.332],
    subDistricts: [
      'Ping Shek (坪石)',
      'Kowloon Bay (九龍灣)',
      'Ngau Tau Kok (牛頭角)',
      'Jordan Valley (佐敦谷)',
      'Kwun Tong (觀塘)',
      'Sau Mau Ping (秀茂坪)',
      'Lam Tin (藍田)',
      'Yau Tong (油塘)',
      'Lei Yue Mun (鯉魚門)',
    ],
  },
  {
    id: 'kwai-tsing',
    nameEn: 'Kwai Tsing',
    nameZh: '葵青',
    regionId: 'new-territories',
    bbox: [114.089, 22.304, 114.156, 22.384],
    subDistricts: ['Kwai Chung (葵涌)', 'Tsing Yi (青衣)'],
  },
  {
    id: 'tsuen-wan',
    nameEn: 'Tsuen Wan',
    nameZh: '荃灣',
    regionId: 'new-territories',
    bbox: [114.07, 22.333, 114.152, 22.404],
    subDistricts: [
      'Tsuen Wan (荃灣)',
      'Lei Muk Shue (梨木樹)',
      'Ting Kau (汀九)',
      'Sham Tseng (深井)',
      'Tsing Lung Tau (青龍頭)',
      'Ma Wan (馬灣)',
      'Sunny Bay (欣澳)',
    ],
  },
  {
    id: 'tuen-mun',
    nameEn: 'Tuen Mun',
    nameZh: '屯門',
    regionId: 'new-territories',
    bbox: [113.886, 22.323, 114.052, 22.438],
    subDistricts: ['Tai Lam Chung (大欖涌)', 'So Kwun Wat (掃管笏)', 'Tuen Mun (屯門)', 'Lam Tei (藍地)'],
  },
  {
    id: 'yuen-long',
    nameEn: 'Yuen Long',
    nameZh: '元朗',
    regionId: 'new-territories',
    bbox: [113.895, 22.361, 114.076, 22.53],
    subDistricts: [
      'Hung Shui Kiu (洪水橋)',
      'Ha Tsuen (厦村)',
      'Lau Fau Shan (流浮山)',
      'Tin Shui Wai (天水圍)',
      'Yuen Long (元朗)',
      'San Tin (新田)',
      'Lok Ma Chau (落馬洲)',
      'Kam Tin (錦田)',
      'Shek Kong (石崗)',
      'Pat Heung (八鄉)',
    ],
  },
  {
    id: 'north',
    nameEn: 'North',
    nameZh: '北區',
    regionId: 'new-territories',
    bbox: [114.08, 22.463, 114.267, 22.568],
    subDistricts: [
      'Fanling (粉嶺)',
      'Luen Wo Hui (聯和墟)',
      'Sheung Shui (上水)',
      'Shek Wu Hui (石湖墟)',
      'Sha Tau Kok (沙頭角)',
      'Luk Keng (鹿頸)',
      'Wu Kau Tang (烏蛟騰)',
    ],
  },
  {
    id: 'tai-po',
    nameEn: 'Tai Po',
    nameZh: '大埔',
    regionId: 'new-territories',
    bbox: [114.104, 22.412, 114.264, 22.525],
    subDistricts: [
      'Tai Po Market (大埔墟)',
      'Tai Po (大埔)',
      'Tai Po Kau (大埔滘)',
      'Tai Mei Tuk (大尾篤)',
      'Shuen Wan (船灣)',
      'Cheung Muk Tau (樟木頭)',
      'Kei Ling Ha (企嶺下)',
    ],
  },
  {
    id: 'sha-tin',
    nameEn: 'Sha Tin',
    nameZh: '沙田',
    regionId: 'new-territories',
    bbox: [114.15, 22.356, 114.249, 22.441],
    subDistricts: [
      'Tai Wai (大圍)',
      'Sha Tin (沙田)',
      'Fo Tan (火炭)',
      'Ma Liu Shui (馬料水)',
      'Wu Kai Sha (烏溪沙)',
      'Ma On Shan (馬鞍山)',
    ],
  },
  {
    id: 'sai-kung',
    nameEn: 'Sai Kung',
    nameZh: '西貢',
    regionId: 'new-territories',
    bbox: [114.227, 22.285, 114.386, 22.452],
    subDistricts: [
      'Clear Water Bay (清水灣)',
      'Sai Kung (西貢)',
      'Tai Mong Tsai (大網仔)',
      'Tseung Kwan O (將軍澳)',
      'Hang Hau (坑口)',
      'Tiu Keng Leng (調景嶺)',
      'Ma Yau Tong (馬游塘)',
    ],
  },
  {
    id: 'islands',
    nameEn: 'Islands',
    nameZh: '離島',
    regionId: 'new-territories',
    bbox: [113.835, 22.153, 114.34, 22.351],
    subDistricts: [
      'Cheung Chau (長洲)',
      'Peng Chau (坪洲)',
      'Lantau Island including Tung Chung (大嶼山包括東涌)',
      'Lamma Island (南丫島)',
    ],
  },
]

